import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Tippy from '@tippyjs/react';
import styled from 'styled-components';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/shift-toward.css';
import { sticky, followCursor } from 'tippy.js';
import { Size } from '../../../Constants/System';
import ButtonGroup from '../Button/ButtonGroup';
import Button from '../Button/Button';
const defaultProps = {
    animation: 'shift-toward',
    placement: 'left',
    delay: [50, 0],
    offset: [0, 16],
    duration: [250, 250],
};
export default function Tooltip(props) {
    let title = null;
    if (props.title) {
        title = (_jsx("div", { className: "tooltip__heading", children: _jsx("h5", { className: "heading-text", children: props.title }) }));
    }
    let text = null;
    if (props.text) {
        text = _jsx("p", { className: "body-text", children: props.text });
    }
    let buttons = null;
    if (props.actions?.length) {
        buttons = (_jsx(ButtonGroup, { className: "btn-container", children: props.actions.map((action, i) => (_createElement(Button, { size: Size.small, ...action, key: i }))) }));
    }
    const interactive = props.interactive ? props.interactive : props.actions?.length ? true : false;
    const plugins = [];
    if (props.sticky) {
        plugins.push(sticky);
    }
    if (props.followCursor) {
        plugins.push(followCursor);
    }
    const mergedPlugins = [...new Set([...plugins, ...(props.plugins || [])])];
    const content = (_jsxs("div", { className: "tooltip-body", children: [title, text, props.body, buttons] }));
    const finalProps = {
        ...defaultProps,
        ...props,
        interactive,
        plugins: mergedPlugins,
        content: props.content ?? content,
        $size: props.size,
        $scheme: props.scheme,
    };
    delete finalProps.text;
    delete finalProps.size;
    delete finalProps.scheme;
    delete finalProps.body;
    delete finalProps.actions;
    delete finalProps.title;
    //const theme = useInheritedTheme();
    return _jsx(TooltipContainer, { ...finalProps });
}
const TooltipContainer = styled(Tippy) `
	${({ theme, $scheme: scheme }) => {
    return `
			--tooltip-color: ${!scheme ? theme.palette.shade2 : theme.schemes[scheme].passive};
			--tooltip-text-color: ${!scheme ? theme.primary : theme.schemes[scheme].text};
			--tooltip-button-color: ${!scheme ? theme.palette.shade3 : theme.schemes[scheme].active};
			--tooltip-button-hover-color: ${!scheme ? theme.palette.shade4 : theme.schemes[scheme].hover};
		`;
}}

	background: var(--tooltip-color);
	box-shadow: 0px 0px 30px #00000030;

	.tippy-arrow {
		color: var(--tooltip-color);
	}

	.tippy-content {
		color: var(--tooltip-text-color);
		display: flex;
		justify-content: flex-start;
		flex-direction: column;
		align-items: flex-start;

		.tooltip-body {
			padding: ${(props) => (props.$size === Size.small ? 0 : props.theme.spacing.xs)};

			.tooltip__heading {
				display: flex;
				align-items: center;
				white-space: nowrap;

				.tooltip-close {
					padding: 0;
					margin-left: auto;
					background-color: transparent;
					border-color: transparent;
					width: unset;

					&:hover {
						background-color: transparent;
					}

					&:before {
						animation: none;
						margin-right: 0;
						margin: 0;
						font-size: ${(props) => props.theme.typography.sm};
					}
				}
			}

			.tooltip__heading + .body-text {
				margin-top: ${(props) => props.theme.spacing.xs};
			}

			.heading-text {
				font-weight: bold;
				margin: 0;
				font-size: ${(props) => props.theme.typography.md};
			}

			.body-text {
				font-size: ${(props) => props.theme.typography.sm};
				margin: 0;

				img {
					margin-top: ${(props) => props.theme.spacing.md};
				}
			}

			.btn-container {
				display: flex;
				flex-direction: row;
				justify-content: flex-end;
				margin-top: ${(props) => props.theme.spacing.xs};
				margin-bottom: 0;

				.trigger-joyride-step {
					background: var(--tooltip-button-color);

					&:hover {
						background: var(--tooltip-button-hover-color);
					}
				}

				.skip-joyride {
					&:hover {
						background: var(--tooltip-button-hover-color);
					}
				}
			}
		}
	}
`;
//# sourceMappingURL=Tooltip.js.map